// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AppLeftNav-module__mainMenu__fJpC5 {
  height: 100%;
  width: 72px;
  background: #dbdbe3;
  padding: 18px 0;
}
.AppLeftNav-module__bottomMenu__eBU62 {
  position: absolute;
  bottom: 18px;
  width: 100%;
}
.AppLeftNav-module__envContainer__DrwMp {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
  border-radius: 1px;
}
.AppLeftNav-module__menuItem__UcuNJ {
  padding: 0 !important;
  margin: 0 !important;
  width: 72px !important;
  height: 62px !important;
  border-radius: 0 !important;
}
.AppLeftNav-module__menuItemLink__R0vSg {
  position: relative;
  width: 72px;
  height: 54px;
  border-radius: 0;
}
.AppLeftNav-module__menuItemLink__R0vSg :hover {
  color: #121215;
  font-weight: 500;
}
.AppLeftNav-module__menuItemLink__R0vSg :hover svg path {
  fill: #121215;
}
.AppLeftNav-module__menuLinkContent__u9Y7G {
  position: absolute;
  top: 0;
  left: 0;
  width: 72px;
  height: 62px;
  padding: 6px 9px 2px 9px;
  background: #dbdbe3;
  color: var(--cool-grey-10, #303048);
  text-align: center;
  font-family: Nunito;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 200% */
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.AppLeftNav-module__menuLinkContentActive__rFLnR,
.AppLeftNav-module__menuLinkContentActive__rFLnR:hover {
  background: #c2c2d0;
  color: #531dab;
  font-weight: 500;
}
.AppLeftNav-module__menuLinkContentActive__rFLnR svg path,
.AppLeftNav-module__menuLinkContentActive__rFLnR:hover svg path {
  fill: #531dab;
}
.AppLeftNav-module__exceptionIconContainer__Igax8 {
  position: relative;
  height: 28px;
}
.AppLeftNav-module__exceptionDot__x6BMk {
  position: absolute;
  width: 6px;
  height: 6px;
  top: 0;
  right: 0;
  background-color: #cf1322;
  border-radius: 4px;
}
.AppLeftNav-module__envTag__E79n4 {
  margin: 0 6px;
  border-radius: 1px;
  background: #d1d1db;
  text-align: center;
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/views/AppLeftNav.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;AACF;AAEA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;AAAF;AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AADF;AAIA;EACE,qBAAA;EACA,oBAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AAFF;AAKA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAHF;AADA;EAOI,cAAA;EACA,gBAAA;AAHJ;AALA;EAWQ,aAAA;AAHR;AASA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,mBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EAPA,SAAS;EAQT,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AANF;AASA;;EAEE,mBAAA;EACA,cAAA;EACA,gBAAA;AAPF;AAGA;;EAOM,aAAA;AANN;AAWA;EACE,kBAAA;EACA,YAAA;AATF;AAYA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;EACA,kBAAA;AAVF;AAYA;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAVF","sourcesContent":[".mainMenu {\n  height: 100%;\n  width: 72px;\n  background: #dbdbe3;\n  padding: 18px 0;\n}\n\n.bottomMenu {\n  position: absolute;\n  bottom: 18px;\n  width: 100%;\n}\n\n.envContainer {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 12px;\n  border-radius: 1px;\n}\n\n.menuItem {\n  padding: 0 !important;\n  margin: 0 !important;\n  width: 72px !important;\n  height: 62px !important;\n  border-radius: 0 !important;\n}\n\n.menuItemLink {\n  position: relative;\n  width: 72px;\n  height: 54px;\n  border-radius: 0;\n\n  :hover {\n    color: #121215;\n    font-weight: 500;\n    svg {\n      path {\n        fill: #121215;\n      }\n    }\n  }\n}\n\n.menuLinkContent {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 72px;\n  height: 62px;\n  padding: 6px 9px 2px 9px;\n  background: #dbdbe3;\n  color: var(--cool-grey-10, #303048);\n  text-align: center;\n  font-family: Nunito;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 200% */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n}\n\n.menuLinkContentActive,\n.menuLinkContentActive:hover {\n  background: #c2c2d0;\n  color: #531dab;\n  font-weight: 500;\n  svg {\n    path {\n      fill: #531dab;\n    }\n  }\n}\n\n.exceptionIconContainer {\n  position: relative;\n  height: 28px;\n}\n\n.exceptionDot {\n  position: absolute;\n  width: 6px;\n  height: 6px;\n  top: 0;\n  right: 0;\n  background-color: #cf1322;\n  border-radius: 4px;\n}\n.envTag {\n  margin: 0 6px;\n  border-radius: 1px;\n  background: #d1d1db;\n  text-align: center;\n  max-width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainMenu": `AppLeftNav-module__mainMenu__fJpC5`,
	"bottomMenu": `AppLeftNav-module__bottomMenu__eBU62`,
	"envContainer": `AppLeftNav-module__envContainer__DrwMp`,
	"menuItem": `AppLeftNav-module__menuItem__UcuNJ`,
	"menuItemLink": `AppLeftNav-module__menuItemLink__R0vSg`,
	"menuLinkContent": `AppLeftNav-module__menuLinkContent__u9Y7G`,
	"menuLinkContentActive": `AppLeftNav-module__menuLinkContentActive__rFLnR`,
	"exceptionIconContainer": `AppLeftNav-module__exceptionIconContainer__Igax8`,
	"exceptionDot": `AppLeftNav-module__exceptionDot__x6BMk`,
	"envTag": `AppLeftNav-module__envTag__E79n4`
};
export default ___CSS_LOADER_EXPORT___;
